// ─── Ovvo Camping — Gestione consenso cookie/privacy ────────────────────────
// Consenso salvato in localStorage. Le statistiche interne (analytics-tracker)
// partono solo dopo il consenso.

const KEY = "ovvo_consent"; // "accepted" | "rejected"

export type ConsentValue = "accepted" | "rejected" | null;

type Listener = (value: ConsentValue) => void;
const listeners = new Set<Listener>();

export function getConsent(): ConsentValue {
  try {
    const v = localStorage.getItem(KEY);
    return v === "accepted" || v === "rejected" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(value: "accepted" | "rejected") {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // storage non disponibile: procedi comunque
  }
  if (value === "rejected") clearTrackingStorage();
  listeners.forEach((fn) => fn(value));
}

export function onConsentChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Rimuove gli identificativi già salvati se l'utente rifiuta
function clearTrackingStorage() {
  try {
    localStorage.removeItem("ovvo_vid");
    localStorage.removeItem("ovvo_visited");
    sessionStorage.removeItem("ovvo_sid");
    sessionStorage.removeItem("ovvo_s_started");
  } catch {
    // ignora
  }
}
